import { IController, IWindowService } from 'angular';
import * as _ from 'lodash';
import { Cohort } from '../../../../../../../ng2/shared/constants/cohort.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class GradPlanningMetricCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils', 'Rollbar', '$window', '$state'];

  public currentCohortFilter;
  public cohortUrlParam;

  constructor(
    public $scope,
    private WizardUtils: WizardUtils,
    private Rollbar,
    private $window: IWindowService,
    private $state,
  ) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    const filter = this.WizardUtils.getEntireSdcFilter();
    this.currentCohortFilter = _.last(filter.cohort);
    const currentCohortDetails = Cohort[this.currentCohortFilter];

    // Debugging: Sometimes currentCohortDetails is undefined. I'm guessing it's because
    // the filter.cohort is null or undefined (JC);
    let currentCohortKey;
    if (currentCohortDetails) {
      currentCohortKey = currentCohortDetails.keyForGradPlanningThresholds;
    } else {
      const warning = new Error(
        `Cohort not defined, using fourthYearCohort. Here's the filter ${JSON.stringify(filter)}`,
      );
      this.Rollbar.warning(warning);
      currentCohortKey = 'fourthYearCohort';
    }

    const keyToUrlParamKey = {
      fourthYearCohort: 'fourth-year-students',
      thirdYearCohort: 'third-year-students',
      secondYearCohort: 'second-year-students',
      firstYearCohort: 'first-year-students',
    };
    this.cohortUrlParam = keyToUrlParamKey[currentCohortKey];
  }

  goToState(): void {
    const route = `main.school.settings.metrics.grad-planning.${this.cohortUrlParam}`;
    this.$window.open(this.$state.href(route), '_blank');
  }
}
